import Vue from 'vue'
import type VueRouter from 'vue-router'
import type { Route } from 'vue-router'

const VIEW_FILE_REGEX = /import\(['"]([^'"]+?View\.vue)/

const logView = (path: string, view: string) => {
  Vue.prototype.$log.debug(`${path} → ${view}`)
}

export const installRouteViewLogger = (router: VueRouter): void => {
  const viewByName = new Map<string, string>()

  router.getRoutes().forEach((record) => {
    const view = (record.components?.default?.toString() ?? '').match(VIEW_FILE_REGEX)?.[1]
    if (record.name && view) {
      viewByName.set(record.name, view)
    }
  })

  router.afterEach((to: Route) => {
    const view = viewByName.get(to.name ?? '')
    if (view) {
      logView(to.fullPath, view)
    }
  })
}
